/* BannerContent.tsx generated by @compiled/babel-plugin v2.0.0 */
import { forwardRef } from 'react';
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2sNsIg20Hp%7Bfont%3Avar(--ds-font-body-large%2Cnormal%20400%201pc%2F24px%20%22Atlassian%20Sans%22%2Cui-sans-serif%2C-apple-system%2CBlinkMacSystemFont%2C%22Segoe%20UI%22%2CUbuntu%2C%22Helvetica%20Neue%22%2Csans-serif)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1mT5xdRAKS%7Bposition%3Arelative%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._39xV02N91d%7Bwidth%3A100%25%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._42Yu6BA6TK%7Bz-index%3A9999%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0KLXruDM2k%7Bbackground-color%3Avar(--ds-background-brand-bold%2C%231868db)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1UtDYze5R3%7Bcolor%3Avar(--ds-text-inverse%2C%23fff)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0Of8r25zaO%7Bpadding-top%3Avar(--ds-space-200%2C1pc)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1Znuxb5zaO%7Bpadding-right%3Avar(--ds-space-200%2C1pc)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1wydGW5zaO%7Bpadding-bottom%3Avar(--ds-space-200%2C1pc)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2Zuz6Q5zaO%7Bpadding-left%3Avar(--ds-space-200%2C1pc)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3iDTPbgBM8%7Bdisplay%3Agrid%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2iEGP2clzJ%7Bgrid-template-columns%3A1fr%20auto%201fr%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0hPCNLDIqT%7Balign-items%3Acenter%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._17lj8p5zaO%7B-moz-column-gap%3Avar(--ds-space-200%2C1pc)%3Bcolumn-gap%3Avar(--ds-space-200%2C1pc)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0jFU0VIZbP%7Bheight%3Aauto%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._24h04i2Njc%7Bbox-sizing%3Aborder-box%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2mHwu82ADO%7Bgap%3Avar(--ds-space-100%2C8px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2j3gqAiZR3%7Bgrid-column%3A2%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3iDTPbQ4SZ%7Bdisplay%3Aflex%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._37wbyuDIqT%7Bjustify-content%3Acenter%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2j3gqA7LI7%7Bgrid-column%3A3%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._37wbyuz9WS%7Bjustify-content%3Aflex-end%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0luBOg98eZ%20a%7Btext-decoration-color%3AcurrentColor%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2h5UOz0Rl6%20a%7Btext-decoration-line%3Aunderline%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3W2WEt6wH8%20a%7Btext-decoration-style%3Asolid%7D");
import React, { useCallback, useEffect, useMemo } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

// eslint-disable-next-line import/no-extraneous-dependencies -- Platform-provided dependency
import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import Button from '@atlaskit/button/new';
import CrossIcon from '@atlaskit/icon/core/cross';
import WarningIcon from '@atlaskit/icon/core/status-warning';
import Link from '@atlaskit/link';
import { TIME_CONSTANTS } from '../../../constants/time';
import { useUrlExclusion } from '../hooks/useUrlExclusion';
import { messages } from '../messages';
import { getSessionUrgencyLevel } from '../utils/urgencyLevel';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const StyledBanner = forwardRef(({
  as: C = "div",
  style: __cmpls,
  ...__cmplp
}, __cmplr) => {
  return <C {...__cmplp} style={__cmpls} ref={__cmplr} className={ax(["_2sNsIg20Hp _1mT5xdRAKS _39xV02N91d _42Yu6BA6TK _0KLXruDM2k _1UtDYze5R3 _0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO _3iDTPbgBM8 _2iEGP2clzJ _0hPCNLDIqT _17lj8p5zaO _0jFU0VIZbP _24h04i2Njc", __cmplp.className])} />;
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
if (process.env.NODE_ENV !== 'production') {
  StyledBanner.displayName = 'StyledBanner';
}
const StyledCenteredContent = forwardRef(({
  as: C = "div",
  style: __cmpls,
  ...__cmplp
}, __cmplr) => {
  return <C {...__cmplp} style={__cmpls} ref={__cmplr} className={ax(["_2mHwu82ADO _2j3gqAiZR3 _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT", __cmplp.className])} />;
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
if (process.env.NODE_ENV !== 'production') {
  StyledCenteredContent.displayName = 'StyledCenteredContent';
}
const StyledButtonWrapper = forwardRef(({
  as: C = "div",
  style: __cmpls,
  ...__cmplp
}, __cmplr) => {
  return <C {...__cmplp} style={__cmpls} ref={__cmplr} className={ax(["_2j3gqA7LI7 _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuz9WS", __cmplp.className])} />;
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
if (process.env.NODE_ENV !== 'production') {
  StyledButtonWrapper.displayName = 'StyledButtonWrapper';
}
const StyledLinkWrapper = forwardRef(({
  as: C = "span",
  style: __cmpls,
  ...__cmplp
}, __cmplr) => {
  return <C {...__cmplp} style={__cmpls} ref={__cmplr} className={ax(["_0luBOg98eZ _2h5UOz0Rl6 _3W2WEt6wH8", __cmplp.className])} />;
});
if (process.env.NODE_ENV !== 'production') {
  StyledLinkWrapper.displayName = 'StyledLinkWrapper';
}
export interface BannerContentProps {
  /** Time remaining in milliseconds */
  timeRemainingMs: number;
  /** Whether the dismiss button should be shown */
  canDismiss: boolean;
  /** Handler for dismiss action */
  onDismiss: () => void;
  /** Handler for re-authentication action */
  onReauthenticate: (event: React.MouseEvent) => void;
  /** Session expiry timestamp for analytics */
  sessionExpiryTimestamp: number | null;
}

/**
 * Session expiration warning banner component.
 *
 * Displays a prominent warning when the user's session is approaching expiration,
 * with formatted time remaining and options to refresh session or dismiss the banner.
 *
 * Features:
 * - Internationalized time formatting with proper pluralization
 * - Accessibility support (ARIA live region, semantic roles, screen reader labels)
 * - Conditional dismiss functionality (disabled when < 15 minutes remaining)
 * - Performance optimized with React.memo and memoized time formatting
 * - Responsive grid layout that maintains centered content
 *
 * Accessibility:
 * - Uses role="alert" and aria-live="polite" for screen reader announcements
 * - Semantic button and link elements with proper labels
 * - High contrast styling for visibility
 *
 * Performance:
 * - Memoized with React.memo to prevent unnecessary re-renders
 * - Time formatting cached with useMemo to avoid recalculation
 * - Optimized for frequent updates (banner refreshes every few seconds)
 *
 * @param props - Banner configuration and event handlers
 * @returns Styled banner component with session expiration warning
 */
const BannerContent: React.MemoExoticComponent<({
  timeRemainingMs,
  canDismiss,
  onDismiss,
  onReauthenticate,
  sessionExpiryTimestamp
}: BannerContentProps) => JSX.Element | null> = React.memo(({
  timeRemainingMs,
  canDismiss,
  onDismiss,
  onReauthenticate,
  sessionExpiryTimestamp
}: BannerContentProps): JSX.Element | null => {
  const intl = useIntl();
  const {
    createAnalyticsEvent
  } = useAnalyticsEvents();

  // Check if current URL is excluded from showing the banner (dynamic - tracks URL changes)
  const {
    urlIsExcluded,
    matchedPattern
  } = useUrlExclusion();
  const trackReauthClick = useCallback(() => {
    createAnalyticsEvent({
      action: 'clicked',
      actionSubject: 'button',
      actionSubjectId: 'reauth',
      eventType: 'ui',
      source: 'heartbeat',
      attributes: {
        timeRemainingMs,
        urgencyLevel: getSessionUrgencyLevel(timeRemainingMs),
        sessionExpiryTimestamp: Date.now() + timeRemainingMs
      }
    }).fire('heartbeat');
  }, [createAnalyticsEvent, timeRemainingMs]);
  const trackDismissClick = useCallback(() => {
    createAnalyticsEvent({
      action: 'clicked',
      actionSubject: 'button',
      actionSubjectId: 'dismiss',
      eventType: 'ui',
      source: 'heartbeat',
      attributes: {
        timeRemainingMs,
        canDismiss,
        urgencyLevel: getSessionUrgencyLevel(timeRemainingMs)
      }
    }).fire('heartbeat');
  }, [createAnalyticsEvent, timeRemainingMs, canDismiss]);
  const handleReauthenticate = useCallback((event: React.MouseEvent) => {
    trackReauthClick();
    onReauthenticate(event);
  }, [trackReauthClick, onReauthenticate]);
  const handleDismiss = useCallback(() => {
    trackDismissClick();
    onDismiss();
  }, [trackDismissClick, onDismiss]);

  /**
   * Formats session time remaining with proper pluralization and internationalization.
   *
   * Handles multiple edge cases:
   * - Expired sessions (timeRemainingMs <= 0)
   * - Less than one minute remaining
   * - Hours and minutes combinations
   * - Proper pluralization for different languages
   * - Display adjustment to account for partial minutes
   *
   * Performance: Memoized to prevent recalculation when time hasn't changed.
   * The banner updates every few seconds, so this optimization prevents
   * unnecessary string formatting and i18n calls.
   *
   * @returns Formatted time string ready for display (e.g., "Session expires in 5 minutes")
   */
  const formattedTime = useMemo((): string => {
    if (timeRemainingMs <= 0) {
      return intl.formatMessage(messages.sessionExpired);
    }
    const totalSeconds = Math.floor(timeRemainingMs / 1000);

    // If less than one minute remaining
    if (totalSeconds < TIME_CONSTANTS.SECONDS_PER_MINUTE) {
      return `${intl.formatMessage(messages.sessionExpiresPrefix)} ${intl.formatMessage(messages.lessThanOneMinute)}`;
    }

    // Add display adjustment to account for the current partial minute
    const adjustedMinutes = Math.floor(totalSeconds / TIME_CONSTANTS.SECONDS_PER_MINUTE) + TIME_CONSTANTS.DISPLAY_ADJUSTMENT_MINUTES;
    const hours = Math.floor(adjustedMinutes / TIME_CONSTANTS.MINUTES_PER_HOUR);
    const minutes = adjustedMinutes % TIME_CONSTANTS.MINUTES_PER_HOUR;
    const prefix = intl.formatMessage(messages.sessionExpiresPrefix);
    if (hours > 0) {
      const hourStr = hours === 1 ? intl.formatMessage(messages.hour) : intl.formatMessage(messages.hours);
      const minStr = minutes === 1 ? intl.formatMessage(messages.minute) : intl.formatMessage(messages.minutes);
      const andStr = intl.formatMessage(messages.and);
      return `${prefix} ${hours} ${hourStr} ${andStr} ${minutes} ${minStr}`;
    }
    const minStr = minutes === 1 ? intl.formatMessage(messages.minute) : intl.formatMessage(messages.minutes);
    return `${prefix} ${minutes} ${minStr}`;
  }, [timeRemainingMs, intl]);

  // Fire analytics event when URL is excluded
  useEffect(() => {
    if (urlIsExcluded && matchedPattern && sessionExpiryTimestamp) {
      createAnalyticsEvent({
        action: 'excluded',
        actionSubject: 'banner',
        actionSubjectId: 'sessionWarning',
        eventType: 'operational',
        source: 'heartbeat',
        attributes: {
          url: window.location.href,
          pattern: matchedPattern,
          sessionExpiryTimestamp
        }
      }).fire('heartbeat');
    }
  }, [urlIsExcluded, matchedPattern, sessionExpiryTimestamp, createAnalyticsEvent]);

  // Don't render banner if URL is excluded
  if (urlIsExcluded) {
    return null;
  }
  return <StyledBanner data-testid="session-expiration-banner" role="alert" aria-live="polite">
				<StyledCenteredContent>
					<WarningIcon label={intl.formatMessage(messages.warningIconLabel)} size="medium" color="currentColor" testId="warning-icon" />
					<span>
						{formattedTime}.{' '}
						<StyledLinkWrapper>
							<Link appearance="inverse" href="/logout" onClick={handleReauthenticate}>
								<FormattedMessage {...messages.loginAgainLink} />
							</Link>
						</StyledLinkWrapper>
					</span>
				</StyledCenteredContent>
				{canDismiss && <StyledButtonWrapper>
						<Button appearance="primary" iconBefore={CrossIcon} onClick={handleDismiss} testId="dismiss-session-banner">
							<FormattedMessage {...messages.remindMeLaterLabel} />
						</Button>
					</StyledButtonWrapper>}
			</StyledBanner>;
});
export default BannerContent;